﻿import React, {useCallback, useEffect, useState} from 'react';
import { useDispatch } from "react-redux";
import {ProductSpecificationDto} from "../../product-models";
import SpecCollection from "./SpecCollection";
import {getSpecs} from "../../store/actionCreators/getSpec";
import {collapseAllSpecs, expandAllSpecs} from "../../store/actionCreators/specDisplayManagement";
import {useTypedSelector} from "../../hooks/useTypeSelector";
import {i18n} from "../../helpers/localisation-helpers";


interface SpecificationProps {
    specApiUrl: string;
    productName: string;
    regionCode: string;
}

const Specification = (props:SpecificationProps) => {
    const dispatch = useDispatch();

    const { specificationsData, loaded, pending} = useTypedSelector((state) => state.specs);
    const { productData } = useTypedSelector((state) => state.product);
    const [isWarranty, setIsWarranty] = useState(true);
    
    useEffect(() => {
        if(productData.ProductSubType != "Warranty" && productData.ProductName.toLowerCase() !== "optoma management suite") {
            dispatch(getSpecs(props.productName, props.regionCode, props.specApiUrl));
            setIsWarranty(false);
        }
    }, [])
    
    const collapseAll = () => {
        dispatch(collapseAllSpecs());
    }

    const expandAll = () => {
        dispatch(expandAllSpecs());
    }
    
    if(pending && !isWarranty) {
        return (
            <div>
                Loading...
            </div>
        )
    }
    
    if(isWarranty) {
        return null;
    }

    return (
        <div className="specification">
            <div className="onepcssgrid-1300 onepcssblockgrid">
                <div className="onerow">
                    <div className="col-12 last content">
                        <h2><a id="specifications">{i18n("Resource.specification", productData.PageLocalisations)}</a></h2>
                        
                        <div className="collapse-controls">
                            <a onClick={() => expandAll()}>Show all</a>
                            <a onClick={() => collapseAll()}>Hide all</a>
                        </div>
                        
                        {specificationsData && specificationsData.SpecCollections.map((collection, index) => {
                            return <SpecCollection 
                            key={collection.CollectionName} 
                            collection={collection} 
                            />
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Specification